export enum StepsOnboarding {
  communityEdit = 'communityEdit',
  communityMember = 'communityMember',
  communityPostCreate = 'communityPostCreate',
  communityShare = 'communityShare'
}

export type PutOnboardingProps = {
  idCommunity: number
  stepOnboarding: StepsOnboarding
  payload: {
    [key: string]: boolean
  }
}

export type CommunityEdit = {
  communityName: boolean
  communityImage: boolean
}

export type CommunityMember = {
  communityModerators: boolean
}

export type CommunityPostCreate = {
  communityFirstPost: boolean
}

export type CommunityShare = {
  communityShare: boolean
}

export type OnboardingSteps = {
  communityAdmin: {
    communityEdit: CommunityEdit
    communityMember: CommunityMember
    communityPostCreate: CommunityPostCreate
    communityShare: CommunityShare
  }
}

export type ResponseGetOnboarding = {
  progress: number
} & OnboardingSteps

export enum PromptTypes {
  WELCOME_POST = 'COMMUNITY_WELCOME_POST',
  RULES_POST = 'COMMUNITY_RULES_POST',
  INTERACTION_POST = 'COMMUNITY_INTERACTION_POST'
}

export type GetOnboardingIA = {
  promptType: PromptTypes
  locale: string
}

export type ResponseGetOnboardingIA = {
  title: string
  text: string
}
